import React from 'react';

export default () => {
    return (
        <React.Fragment>
            <h1>Error 404: Page Not Found</h1>
            <h2>What you're looking for does not exist, like a drink admin when drink is empty</h2>
        </React.Fragment>
    );
};
